module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_5.8ca3124c.png";